module.exports = __webpack_public_path__ + "files/47e8896aa53603a1e692abd23760cd4e.png";